import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const EventPage = lazy(() => import('../pages/event/page'));
const GalleryAdminPage = lazy(() => import('../pages/gallery-admin/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/event',
    element: <EventPage />,
  },
  {
    path: '/gallery-admin',
    element: <GalleryAdminPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
